import _ from 'lodash';
import Vue from 'vue';
import Autocomplete from '@trevoreyre/autocomplete-vue';
Vue.use(Autocomplete);
import Chart from './components/Chart.vue';
import draggable from 'vuedraggable';
var axios = require('axios');

var L = require('leaflet');
var L = require('./leaflet.numbered.divicon')(L);

import { GestureHandling } from "leaflet-gesture-handling";

var H = require('./helpers.js');

L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

var tura_utvonal_layer = L.layerGroup([]);

var tura_kezdopont_layer = L.layerGroup([]);

$('.collapse-coordinates').on('click', function () {
    console.log('asd');
});

var turatervezo = new Vue({
  el: 'section.tura-tervezo',
  components: {
    Autocomplete, draggable, Chart
  },
  data: {
    found_object: {},
    text: '',
    points: [],
    names: [],
    features: [],
    turatipus: 'cycling-regular',
    gpxfile: null,
    track_time: '',
    track_distance: '',
    track_ascent: '',
    track_descent: '',
    mode: 'automatikus',
    planned_coordinates: [],
    chart: null
  },
  methods: {
    gpxUpload() {
        var v = this;
        let formData = new FormData();
        formData.append('gpx-file', this.gpxfile);

        axios.post('/tura/tervezo/gpximport', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(function(data) {
          v.points = data.data['points'];
          v.mode = 'egyedi';
          v.plan();
        });
    },
    onChangeFileUpload(){
      this.gpxfile = this.$refs.file.files[0];
    },
    turatipusValto(event) {
        if (event.target.value) {
            this.turatipus = event.target.value;
        }else{
            this.turatipus = '';
            this.mode = 'egyedi';
        }
        this.plan();
    },
    remove(index) {
        this.points.splice(index,1);
        this.plan();
    },
    add_point () {
        this.points.push({point: this.found_object, name: this.found_object});
    },
    search: function(input) {
        return new Promise((resolve, reject) => {
          if (input.length < 3) {
            return reject();
          }
          var geocoder= new google.maps.Geocoder();
          geocoder.geocode( { 'address': input, 'region': 'hu'}, function(results, status) {
            if (status == 'OK') {
                if (results.length) {
                    resolve(results);
                }
            } else {
                reject();
                console.log('Geocode was not successful for the following reason: ' + status);
            }
          });
        });
    },
    getResultValue(result) {
        return result.formatted_address;
    },
    handleSubmit(a) {
        this.points.push({
            point: [a.geometry.location.lng(), a.geometry.location.lat()],
            name: this.$refs.ac.value
        });
        this.$refs.ac.setValue('');
        this.plan();
    },
    plan() {
        this.eraseMap();
        var v = this;
        if (this.points.length > 1) {

            if (v.mode == "egyedi") {
                var coordinates = v.points.map(x => [x.point[1], x.point[0]]);
                v.track_distance = H.calculateDistance(coordinates);
                var speed = 5;
                v.track_time = v.track_distance / speed * 60 * 60 * 1000;
                v.draw(coordinates);
            } else {
                var parts = [];
                for (var i = 0; i < this.points.length-1; i++) {
                    parts.push(this.planPart(this.points[i],this.points[i+1]));
                }
                v.track_time = 0;
                v.track_distance = 0;
                v.track_ascent = 0;
                v.track_descent = 0;
                v.planned_coordinates = [];
                var waypoints = [];
                var coordinates = [];
                if(parts.length > 0) {
                    axios.all(parts).then(axios.spread(function (...args) {
                        args.forEach(function(response) {
                            if(typeof response == 'undefined') {
                                alert("Valami hiba történt az útvonal lekérdezése közben.");
                                v.points.pop();
                                if(v.points.length == 1) {
                                    var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                                    var marker = L.marker([v.points[0].point[1], v.points[0].point[0]],
                                        {
                                            icon: new L.NumberedDivIcon({number: '1'})
                                        }
                                    ).addTo(map);
                                    v.features.push(marker);
                                }
                            }
                            else {
                                v.track_time     += response.data.features[0].properties.summary.duration * 1000;
                                v.track_distance += response.data.features[0].properties.summary.distance / 1000;
                                v.track_ascent   += response.data.features[0].properties.ascent;
                                v.track_descent  += response.data.features[0].properties.descent;
                                var offset = v.planned_coordinates.length;
                                if (offset > 0) {
                                    response.data.features[0].properties.way_points.shift();
                                    response.data.features[0].geometry.coordinates.shift();
                                    offset -= 1;
                                }
                                v.planned_coordinates = v.planned_coordinates.concat(response.data.features[0].geometry.coordinates.map(x => [x[1], x[0], x[2]]));
        
                                waypoints = waypoints.concat(response.data.features[0].properties.way_points.map(x=>x+offset));
                            }
                        });
                        coordinates = v.planned_coordinates;
                        v.draw(coordinates, waypoints);
                    }));
                }
            }
        } else {
            if (this.points.length == 1) {
                var myIcon = L.divIcon({className: 'fas fa-map-marker div-icon'});
                var marker = L.marker([this.points[0].point[1], this.points[0].point[0]],
                    {
                        icon: new L.NumberedDivIcon({number: '1'})
                    }
                ).addTo(map);
                v.features.push(marker);
            }
        }
    },
    planPart(a, b){
        var response = axios.post('https://api.openrouteservice.org/v2/directions/'+(a.mode ? a.mode : this.turatipus)+'/geojson', {
            coordinates: [a.point, b.point],
            elevation: true,
            instructions: true,
            language: 'en-US',
            preference: a.preference ? a.preference : 'fastest'
          }).catch(function(error) {
            if (error.response) {
                // Request made and server responded
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
              }
          });
          
        return response;
    },
    draw(coordinates, waypoints){
        var polyline = L.polyline(coordinates, {color: '#0C59D0'}).addTo(map);
        this.features.push(polyline);
        //map.fitBounds(polyline.getBounds());
        if (this.mode == "egyedi") {
            for (var key in coordinates) {
                var marker = L.marker([coordinates[key][0], coordinates[key][1]],
                    {
                        icon: new L.NumberedDivIcon({number: (parseInt(key)+1)})
                    }
                ).addTo(map);
                this.features.push(marker);
            }
        }else{
            var v = this;
            $(".js-range-slider-tervezo").data("ionRangeSlider").update({
                max: this.planned_coordinates.length,
                from: 0,
                to: this.planned_coordinates.length,
                onFinish: function(data) {
                    var elevation_data = v.planned_coordinates.map(x => x[2]).splice(data.from, data.to);
                    v.$refs.chart.$emit('newplan', elevation_data, v.track_distance);
                }
            });
            for (var key in waypoints) {
                var key2 = waypoints[key];
                if ( ! key2 in coordinates) {
                    console.log({key: key, key2: key2, coordinates, waypoints});
                }
                var marker = L.marker([coordinates[key2][0], coordinates[key2][1]],
                    {
                        icon: new L.NumberedDivIcon({number: (parseInt(key)+1)})
                    }
                ).addTo(map);
                this.features.push(marker);
            }
            var elevation_data = this.planned_coordinates.map(x => x[2]);
            this.$refs.chart.$emit('newplan', elevation_data, this.track_distance);
        }

    },
    deleteAllPoints () {
        this.eraseMap();
        this.points = [];
    },
    eraseMap () {
        this.features.forEach(function(el, index) {
            map.removeLayer(el);
        });
        //console.log(map);
    },
    gpxDownload() {
        this.download('gpx');
    },
    kmlDownload() {
        this.download('kml');
    },
    download(format) {
        axios.post('/download/'+format,{
          coordinates: (this.mode=="egyedi" ? this.points.map(x=>x.point) : this.planned_coordinates),
          duration: this.track_time / 1000,
          distance: this.track_distance * 1000,
          ascent: this.track_ascent,
          descent: this.track_descent,
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'cultractive_turatervezo_'+ H.today() + '.' + format);
          document.body.appendChild(link);
          link.click();
        });
    },
    changeMode(event) {
        this.mode = event.target.value;
        this.plan();
    },
    changePartMode(event, index){
        this.points[index].mode = event.target.value;
        this.plan();
    },
    changePartPreference(event, index){
        this.points[index].preference = event.target.value;
        this.plan();
    },
    turaMentes(szervezett) {
        axios.post('/tura/tervezo',{
          coordinates: (this.mode=="egyedi" ? this.points.map(x=>x.point.reverse()) : this.planned_coordinates),
          mode: this.mode,
          turatipus: this.turatipus,
          track_time: this.track_time,
          track_distance: this.track_distance,
          track_ascent: this.track_ascent,
          track_descent: this.track_descent,
        }).then((response) => {
          document.location = '/tura/tervezo/adatok/' + response.data.id + (szervezett ? '?szervezett=1' : '');
          console.log(response);
        });
    }
  }
});

if (document.getElementById("map")) {
    var map = L.map('map', {gestureHandling: true}).setView([47.68,17.63], 10);
    map.on("click", function(e) {
        turatervezo.points.push({point: [e.latlng.lng, e.latlng.lat], name: Number((e.latlng.lng).toFixed(6)) + '; ' + Number((e.latlng.lat).toFixed(6))});
        turatervezo.plan();
        map.setView([e.latlng.lat, e.latlng.lng]);
    });
    //map.scrollWheelZoom.disable();
    L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        maxZoom: 18,
    }).addTo(map);

    navigator.geolocation.getCurrentPosition(function(position) {
        const lng = position.coords.longitude;
        const lat = position.coords.latitude;
        map.setView([lat,lng], 10);
    });
}

jQuery(document).ready(function($) {
    //RangeSlider
    $(".js-range-slider-tervezo").ionRangeSlider({
        type: "double",
        min: 0,
        max: 1000,
        from: 0,
        to: 1000,
        grid: true
    });
});


// WEBPACK FOOTER //
// ./resources/js/turatervezo.js